import { Audit } from '../../types';
import { AuditFormData, PendingZeitraum, ZeitraumFormState } from './auditDetailTypes';

export const createInitialAuditForm = (preselectedProjektId: number): AuditFormData => ({
  name: '',
  beschreibung: '',
  management_summary: '',
  vorbemerkungen: '',
  preflight_datum: '',
  sprache: 'de',
  projektkennung: '',
  projektnummer: '',
  projekt_id: preselectedProjektId,
  audit_type_ids: [],
  audit_status_id: undefined,
  mitarbeiter_ids: [],
});

export const mapAuditToFormData = (audit: Audit): AuditFormData => ({
  name: audit.name,
  beschreibung: audit.beschreibung || '',
  management_summary: audit.management_summary || '',
  vorbemerkungen: audit.vorbemerkungen || '',
  preflight_datum: audit.preflight_datum ? audit.preflight_datum.slice(0, 16) : '',
  sprache: audit.sprache || 'de',
  projektkennung: audit.projektkennung || '',
  projektnummer: audit.projektnummer || '',
  projekt_id: audit.projekt_id,
  audit_type_ids: audit.audit_type_ids || [],
  audit_status_id: audit.audit_status_id,
  mitarbeiter_ids: audit.mitarbeiter_team.map((m) => m.id),
});

export const createEmptyZeitraumForm = (): ZeitraumFormState => ({
  startdatum: '',
  enddatum: '',
  beschreibung: '',
  mitarbeiter_ids: [],
});

export const createPendingZeitraum = (tempId: number): PendingZeitraum => ({
  tempId,
  startdatum: '',
  enddatum: '',
  beschreibung: '',
  mitarbeiter_ids: [],
});
